module.exports = __webpack_public_path__ + "static/media/home-agencia.56f037b4.jpg";